export const SET_SELECTED_SONG = "SET_CURRENT_SONG";
export const TOGGLE_CURRENT_SONG_PLAY = "TOGGLE_CURRENT_SONG_PLAY";

export function setCurrentSong(song) {
  return { type: SET_SELECTED_SONG, payload: { song: song } };
}
export function toggleCurrentSongPlay() {
  return { type: TOGGLE_CURRENT_SONG_PLAY };
}
